// Card Preferences Constants
export const CARD_PREFERENCE_TYPE = {
  CUSTOMER: "customer",
  ADMIN: "admin",
} as const;

export const CARD_PREFERENCE_PAGE = {
  DASHBOARD: "dashboard",
  PROJECT: "project",
} as const;

export type CardPreferenceType = typeof CARD_PREFERENCE_TYPE[keyof typeof CARD_PREFERENCE_TYPE];
export type CardPreferencePage = typeof CARD_PREFERENCE_PAGE[keyof typeof CARD_PREFERENCE_PAGE];

